const endpoints = {
  get_schools: 'https://x.lambda-url.us-west-1.on.aws/?request=fetch-sessions',
  get_file: 'https://raxiyoeyc6.execute-api.us-west-1.amazonaws.com',
  save_file: 'https://raxiyoeyc6.execute-api.us-west-1.amazonaws.com',
}

export default endpoints;